'use strict';


/**
 * PopUp
 * */


import { uxCookie } from "../../Libs/Cookie/main.js";


const Banner = `
	<div class="cookie-inner-wrapper">
		<div class="cookie-inner-wrapper-text"></div>
		
	</div>
	<div class="cookie-btns">

		<button>Понятно</button>
	</div>
`;



export class GDRPCls {
	constructor(options = {}) {
		
		this.options = Object.assign({
			'cookieName': 'hide_popup',
			'gdrpWrapperID': 'cookie-popup',
			'button': {
				'buttonAgreeClassName': '',
				'buttonAgreeText': 'Понятно'
			},	
			'text': '',
			'test': false,
			'callback': ()=>{},
			'timeOutInDays': 0
			
		}, options);


		    if ( uxCookie.get(this.options.cookieName) == 'yes' ) {
		        //
		    } else {
		    	this.popup();
		    	// При нажатии на кнопку ставим cookie, которая будет запрещать показ
		    	// модального окна
			    this.button.addEventListener('click', () => { 
			    	let days = 1; 

			    	if (this.options.timeOutInDays) {
			    	
			    		days = this.options.timeOutInDays * 60 * 24;
			    	}

		            let date = new Date(new Date().getTime() + 60 * 1000 * days);

		            if (!this.options.test) {


			            uxCookie.set(this.options.cookieName, 'yes', {
			            	'path': "/",
			            	'expires': date.toUTCString()
			            })


			        }

			        this.options.callback();

		            // и сразу же скрываем окно
		            this.gdrpWrapper.style.display='none';
		        });

		    }


		    
		}

		popup() {
			let docFragment = document.createDocumentFragment();

			this.gdrpWrapper = document.createElement('div');
			this.gdrpWrapper.setAttribute('id', this.options.gdrpWrapperID);
			docFragment.appendChild(this.gdrpWrapper);

			document.body.appendChild(docFragment);


			this.gdrpWrapper.innerHTML = Banner;


			let textWrapper = this.gdrpWrapper.querySelector('.cookie-inner-wrapper-text');
			textWrapper.innerHTML = this.options.text;


        	this.button = this.gdrpWrapper.querySelector('button');
        	if (this.options.button.buttonAgreeClassName) this.button.classList.add(this.options.button.buttonAgreeClassName);
			this.button.textContent = this.options.button.buttonAgreeText;
			
		}


}
 
